import Vue from 'vue'
import Vuex from 'vuex'

import { UsersSearchStore, USERS_SEARCH_STORE_NAMESPACE } from '@/modules/users/usersSearchStore'

import {
  GPSDevicesSearchStore,
  GPS_DEVICES_SEARCH_STORE_NAMESPACE
} from '@/modules/gps/gpsDevicesSearchStore'

import {
  HuntAreasSearchStore,
  HUNT_AREAS_SEARCH_STORE_NAMESPACE
} from '@/modules/huntareas/huntAreasSearchStore'

import { GamecamStore, GAMECAMS_SEARCH_STORE_NAMESPACE } from '@/modules/gamecams/gamecamStore'

import { AnimalsStore, ANIMALS_STORE_NAMESPACE } from '@/modules/animals/animalsStore'

import { AdsStore, ADS_STORE_NAMESPACE } from '@/modules/ads/adsStore'

import { ResourcesStore, RESOURCES_STORE_NAMESPACE } from '@/modules/resources/resourcesStore'

import { UsersCacheStore } from '@/modules/users/usersCacheStore'

import { HuntAreasCacheStore } from '@/modules/huntareas/huntAreasCacheStore'

export const USERS_CACHE_NAMESPACE = 'usersCache'
export const HUNT_AREAS_CACHE_NAMESPACE = 'huntAreasCache'

Vue.use(Vuex)

const store = new Vuex.Store({
  namespaced: true,

  strict: process.env.NODE_ENV !== 'production',

  modules: {
    [USERS_SEARCH_STORE_NAMESPACE]: UsersSearchStore,
    [GPS_DEVICES_SEARCH_STORE_NAMESPACE]: GPSDevicesSearchStore,
    [HUNT_AREAS_SEARCH_STORE_NAMESPACE]: HuntAreasSearchStore,
    [USERS_CACHE_NAMESPACE]: UsersCacheStore,
    [GAMECAMS_SEARCH_STORE_NAMESPACE]: GamecamStore,
    [HUNT_AREAS_CACHE_NAMESPACE]: HuntAreasCacheStore,
    [ANIMALS_STORE_NAMESPACE]: AnimalsStore,
    [ADS_STORE_NAMESPACE]: AdsStore,
    [RESOURCES_STORE_NAMESPACE]: ResourcesStore
  }
})

export default store
